import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observable, action, computed } from 'mobx';
import { PageStore } from './PageStore';
import { LoadingState } from '../api/LoadingState';
/**
 * Can be used for pages/components with editable content. Adds property `savingState` to disable UI, when saving store content.
 *
 * @author JPk
 */

export var PageEditableStore =
/*#__PURE__*/
function (_PageStore) {
  _inherits(PageEditableStore, _PageStore);

  function PageEditableStore() {
    var _this;

    _classCallCheck(this, PageEditableStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PageEditableStore).apply(this, arguments));
    _this.savingState = LoadingState.Success;
    return _this;
  }
  /**
   * True if data is being saved.
   */


  _createClass(PageEditableStore, [{
    key: "setSavingState",

    /**
     * Sets saving state.
     * @param state
     */
    value: function setSavingState(state) {
      this.savingState = state;
    }
  }, {
    key: "isSaving",
    get: function get() {
      return this.savingState === LoadingState.Pending;
    }
  }]);

  return PageEditableStore;
}(PageStore);

__decorate([observable, __metadata("design:type", Object)], PageEditableStore.prototype, "savingState", void 0);

__decorate([computed, __metadata("design:type", Object), __metadata("design:paramtypes", [])], PageEditableStore.prototype, "isSaving", null);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", void 0)], PageEditableStore.prototype, "setSavingState", null);